import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { ComponentRenderer } from './ComponentRenderer'

interface ContainerProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
  cartId?: string | null
  wishlistId?: string | null
  onCartUpdate?: (cartId: string) => void
  onWishlistUpdate?: (wishlistId: string) => void
}

export function Container({ component, locale, storeId, apiUrl, style, cartId, wishlistId, onCartUpdate, onWishlistUpdate }: ContainerProps) {
  const config = component.config as any
  const maxWidth = config.maxWidth || 'large'

  const maxWidthValues = {
    full: '100%',
    large: '1200px',
    medium: '960px',
    small: '720px',
  }

  const containerStyle: React.CSSProperties = {
    ...style,
    maxWidth: maxWidthValues[maxWidth as keyof typeof maxWidthValues] || maxWidthValues.large,
    margin: '0 auto',
    width: '100%',
  }

  return (
    <div style={containerStyle}>
      {component.children?.map((child) => (
        <ComponentRenderer
          key={child.id}
          component={child}
          locale={locale}
          storeId={storeId}
          apiUrl={apiUrl}
          cartId={cartId}
          wishlistId={wishlistId}
          onCartUpdate={onCartUpdate}
          onWishlistUpdate={onWishlistUpdate}
        />
      ))}
    </div>
  )
}
